var _ = require('underscore');
var Marionette = require('marionette');
var Actions = require('RecordAction');
var Approver = require('RecordApprover');
var Activity = require('RecordActivity');
var Authorization = require('Authorization');
var Classification = require('RecordClassification');
var ClientEngagement = require("RecordClientEngagement");
var Details = require("RecordDetails");
var Documentation = require('RecordDocumentation');
var Entities = require('Entities');
var Lock = require('RecordLock');
var Lookups = EY.Consultation.Lookups;
var MultiTab = require('MultiTab')
var Notification = require('RecordNotification');
var RedboxApis = new Backbone.Collection(EY.Consultation.Resources.RedboxApis);
var Restricted = require('RecordRestricted');
var Stage = require('RecordStage');
var StatusType = Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var Layout = Marionette.View.extend({
    behaviors: [{ behaviorClass: Authorization.RBAC, viewName: 'record' }],
    regions: {
        actions: '#actions',
        activity: '#activity',
        approver: '#approver',
        classification: '#classification',
        client: '#client',
        details: '#details',
        documentation: '#documentation',
        restricted: '#restrictedInfo',
        stage: '#stage',
        piaText: '#piaText'
    },
    template: '#recordLayout',
    ui: {
        activity: '#activity',
        activityHeader: '#activityHeader'
    },
    onRender: function () {
        if (this.model.get('activities').length == 0 || this.model.get('statusTypeId') === StatusType.Complete) {
            this.ui.activityHeader.addClass('hidden');
            this.ui.activity.addClass('hidden');
        }
    },
    onAfterAuthorize: function () {
        var isOpenedByCurrentUser = this.model.get("isOpenedByCurrentUser");
        var lockedBy = this.model.get("lockedBy");
        if (lockedBy && (lockedBy !== User.upn || MultiTab.isOpenedInMultiTab({isOpenedByCurrentUser: isOpenedByCurrentUser}))) {
            this.$el.find("#restricted").prop("disabled", true);
            this.$el.find("#restricted").addClass("disable-link");
        }
        if(this.model.get('validateEngagement')){
            this.$el.find('#clientId').prop("disabled", true);
            this.$el.find('#clientId').addClass('disabled');
            this.$el.find('#clientName').prop("disabled", true);
            this.$el.find('#clientName').addClass('disabled');
            this.$el.find('#engagementId').prop("disabled", true);
            this.$el.find('#engagementId').addClass('disabled');
            this.$el.find('#engagementName').prop("disabled", true);
            this.$el.find('#engagementName').addClass('disabled');
        }
        if (!this.model.get('validateEngagement')) {
            this.$el.find('#engagementSearch').attr('disabled', 'disabled').addClass('disabled');
        }
    }
});

var requiredNotificationPatch = function (options) {
    try {
        var record = options.record;
        var approvers = options.approvers;
        var approval = approvers.length && approvers.findWhere({ approverGroupId: "PartnerInCharge" }).get('approval');
        var date = approval ? new Date(approval).setDate(new Date(approval).getDate() + 15) : new Date();
        var today = new Date();

        if (new Date(date).setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
            record.set({
                completedOn: today,
                modifiedOn: today,
                modifiedBy: 'CONSULTATION-SYSTEM',
                statusTypeId: StatusType.Complete,
                statusResourceKey: StatusType.Complete,
                activities: [],
                communication: ''
            });
            record.save(record.attributes, { validate: false });
        }
    } catch (e) {
        require('Logger').log('RequiredNotificationPatch error - ', e);
    }
}; // Required Notification redbox country patch (on-prem).

var redbox = function (options) {
    var attachments = options.attachments;
    var record = options.record;
    var country = record.get('countryId');
    var api = Lookups.RedBoxCountryApi[country];

    if (api) {
        attachments.url = api + 'Attachment';
        attachments.each(function (model) { model.urlRoot = attachments.url; });
        record.set({
            link: Backbone.history.location.origin + '/#CountryRecord' + country,
            zone: 'redbox',
            zoneKey: +RedboxApis.get(country).get('zoneKey'),
            location: RedboxApis.get(country).get('location')
        });
        record.urlRoot = api + 'Record';
        if (api !== Lookups.API.Consultation && record.get('recordTypeId') === Lookups.RecordType.RequiredNotification && record.get('statusTypeId') === StatusType.UsersNotified) {
            requiredNotificationPatch(options);
        }
    }
}; // Redbox country patch.

var configure = function (options) {
    var approver = options.approvers.findWhere({ upn: User.upn });
    var record = options.record;

    redbox(options);
    record.set({
        whoami: User.upn + '|' + (approver ? approver.get('approverGroupId') : ''),
        approvalBy: record.get('configuration').DisplayApprovalNeededBy ? record.get('approvalBy') : ''
    });
    options.history = _.clone(record.attributes);
};


var start = function (options) {
    var consultation = require('Consultation');
    var record = options.record;
    var layout = new Layout({ model: record });

    consultation.show({ view: layout });

    configure(options);
    if (record.get('statusTypeId') != StatusType.Complete) {
        Lock.start(_.extend({ view: layout }, options));
    }
    Details.start(_.extend({
        region: layout.getRegion('details')
    }, options));
    Classification.start(_.extend({
        region: layout.getRegion('classification')
    }, options));
    ClientEngagement.start(_.extend({
        region: layout.getRegion("client")
    }, options));
    Documentation.start(_.extend({
        region: layout.getRegion('documentation')
    }, options));
    Approver.start(_.extend({
        region: layout.getRegion('approver')
    }, options));
    Stage.start(_.extend({
        region: layout.getRegion('stage')
    }, options));
    Restricted.start(_.extend({
        region: layout.getRegion('restricted')
    }, options));
    Actions.start(_.extend({
        region: layout.getRegion('actions')
    }, options));
    Activity.start(_.extend({
        region: layout.getRegion('activity')
    }, options));
    Notification.start(options);
};

module.exports.start = function (options) {
    var record = options.record;

    options.activities = new Entities.Activities(record.get('activities'));
    options.approvers = new Entities.Approvers(record.get('approvers'));
    options.attachments = new Entities.Attachments(record.get('attachments'));
    options.fields = new Entities.CustomFields(record.get('fields'));
    options.groups = new Entities.ApproverGroups(record.get('configuration').groups);

    start(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/Record.js